<template>
  <CCard class="p-4">
    <CCardBody>
      <h1>{{ $t('Forgot password') }}</h1>
      <p class="text-muted">{{ $t('Enter email assigned to your account') }}</p>
      <CForm @submit.prevent="handleSubmit">
        <RaInput
          size="sm"
          class="filter-input"
          :placeholder="$t('Email')"
          autocomplete="email"
          v-model="email"
          name="email"
          required
        >
          <template #prepend-content>
            <i class="fal fa-user" />
          </template>
        </RaInput>
        <CButton
          color="primary"
          class="px-4 mt-2"
          type="submit"
          data-cy="reset-password-btn"
        >
          {{ $t('Reset password') }}
        </CButton>
      </CForm>
    </CCardBody>
  </CCard>
</template>

<script>
import { AuthService } from '@/services/auth';

export default {
  name: 'ForgotPassword',
  data: function () {
    return {
      email: '',
    };
  },
  methods: {
    async handleSubmit() {
      await AuthService.forgotPassword(this.email);
      alert(this.$t('auth.request_success'));
      this.$router.push({ name: 'Management Login' });
    },
  },
};
</script>
